import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import CourseCard from '../components/Coursecard';
import LuxPageHero from '../components/lux/LuxPageHero';
import LuxCta from '../components/lux/LuxCta';
import { allCourses } from '../data/courses';

const categories = ['All', ...Array.from(new Set(allCourses.map(c => c.category)))];

export default function Courses() {
  const [active, setActive] = useState('All');
  const filtered = active === 'All' ? allCourses : allCourses.filter(c => c.category === active);

  return (
    <>
      <LuxPageHero
        label="All Programs"
        title="Industrial Training"
        highlight="Courses"
        description="16+ job-oriented programs — PLC, automation, SAP, IT and more. Designed for real careers in Noida."
        cta={{ to: '/admission', label: 'Apply Free' }}
      />

      <div className="lux-filter-bar">
        <div className="container-wide" style={{ display: 'flex', gap: 10, overflowX: 'auto', paddingBottom: 4 }}>
          {categories.map(cat => (
            <button key={cat} type="button" className={`filter-pill ${active === cat ? 'filter-pill--active' : ''}`} onClick={() => setActive(cat)}>
              {cat}{active === cat && ` · ${filtered.length}`}
            </button>
          ))}
        </div>
      </div>

      <section className="lux-page-section">
        <div className="container-wide">
          <motion.div layout style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(290px, 1fr))', gap: 24 }}>
            <AnimatePresence mode="popLayout">
              {filtered.map(c => (
                <motion.div key={c.title} layout initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, scale: 0.96 }} transition={{ duration: 0.4 }}>
                  <CourseCard {...c} />
                </motion.div>
              ))}
            </AnimatePresence>
          </motion.div>
        </div>
      </section>

      <LuxCta eyebrow="Not sure?" title="Get free" highlight="counselling" primary={{ to: '/contact', label: 'Contact Us' }} />
    </>
  );
}
